import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http'
import { TipoVehiculo } from '../models';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TipoVehiculoService {

  private ENDPOINT = environment.ENDPOINTS.TIPOVEHICULO;
  private ENDPOINTBOLETO = environment.ENDPOINTS.BOLETO;

  constructor(private http:HttpClient) { }



  getTipoVehiculo(){
    return this.http.get<TipoVehiculo[]>(this.ENDPOINT);
  }

  getClasificacionVehiculo(){
    return this.http.get<TipoVehiculo[]>(this.ENDPOINT).pipe(
      map(data => {
        return data.filter(vehiculo => vehiculo.clasificacion != null);
      })
    );
  }

  getClasificacionTarifa(){
    return this.http.get<any[]>(`${this.ENDPOINTBOLETO}/tarifa/vehiculos`);
  }
}
